module.exports = __webpack_public_path__ + "img/copyLink_b.cfca5197.svg";